import { h } from "preact";

import electron from "../../../foundation/electron";
import classname from "../../../foundation/utils/classname";
import { urlResolve } from "../../../foundation/utils/url";
import Button from "../../v2/Button";
import IconPurchaseSuccess from "../../v2/Icons/IconPurchaseSuccess";

import ParticlesContainer from "./ParticlesContainer";

import styles from "./SuccessStep.module.css";

interface Props {
    type: "workspace" | "personal";
    createdOrganizationId?: string;
    isNativeMacApp?: boolean;
    onClose?: () => void;
}

export default function SuccessStep({ type, createdOrganizationId, isNativeMacApp, onClose }: Props) {
    function onJumpOnboardClicked() {
        if (isNativeMacApp) {
            location.replace(urlResolve("projects", { query: { close: true, ref: "upgrade" } }));
            return;
        }

        if (electron) {
            onClose?.();
            return;
        }

        const replaceURL = type === "personal"
            ? urlResolve("projects", { query: { close: isNativeMacApp } })
            : urlResolve("workspace-members", { url: { oid: createdOrganizationId }, query: { close: isNativeMacApp } });

        location.replace(replaceURL);
    }

    const heading = type === "personal" ? "Voilà — your new plan is now active!" : "Voilà — your new workspace is now active!";
    const caption = type === "personal" ? "You're now the proud owner of a Zeplin plan, thanks for joining the fun!"
        : "You're now the proud owner of a Zeplin workspace, your new hub for your projects and teammates. First up, click the button below to view all your workspace members and assign them roles.";
    const buttonText = type === "personal" || isNativeMacApp ? "Jump on board" : "Manage workspace members";
    return (
        <div class={styles.successStepContainer}>
            <div class={styles.headerContainer}>
                <div class={classname("heading-3", "medium")}>{heading}</div>
                <div class="body-1">{caption}</div>
            </div>
            <div class={styles.imageContainer}>
                <IconPurchaseSuccess/>
            </div>
            <Button onClick={onJumpOnboardClicked}>{buttonText}</Button>
            <ParticlesContainer/>
        </div>
    );
}
